/* Scandinavian Edition — product cards: fetch the hover image before the hover.
   The second card image sits in a clipped slideshow slide with loading="lazy", so the browser
   only fetches it once the slide is shown — i.e. on mouseover, which shows as a blank flash.
   On devices with a mouse we switch that one image to eager when its card nears the viewport. */
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const warm = (card) => {
    const slides = card.querySelectorAll('slideshow-slide:not([hidden])');
    const img = slides[1]?.querySelector('img[loading="lazy"]');
    if (img) img.loading = 'eager';
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        warm(e.target);
      });
    },
    { rootMargin: '300px 0px' }
  );

  const seen = new WeakSet();
  const scan = (root) => {
    root.querySelectorAll?.('product-card').forEach((card) => {
      if (seen.has(card)) return;
      seen.add(card);
      io.observe(card);
    });
  };

  const start = () => {
    scan(document);
    /* Infinite scroll, filters and quick views add cards later */
    new MutationObserver((records) => {
      records.forEach((r) => r.addedNodes.forEach((n) => n.nodeType === 1 && scan(n.parentNode || n)));
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
